/**
 * config
 */
import { InstagramIcon, YoutubeIcon, TwitterIcon, TTIcon, LinkedInPlatformIcon, FacebookIcon } from '@/components/icons';
import { PlatformContentEnum } from '@/pages/campaignCreate/config';

export enum PlatFormEnum {
  TWITTER = "twitter",
  YOUTUBE = "youtube",
  TIKTOK = "tiktok",
  INSTAGRAM = "instagram",
  LINKEDIN = "linkedin",
  // FACEBOOK = "facebook"
}

export const IconLab: any = {
  [PlatFormEnum.YOUTUBE]: YoutubeIcon,
  [PlatFormEnum.INSTAGRAM]: InstagramIcon,
  [PlatFormEnum.TIKTOK]: TTIcon,
  [PlatFormEnum.TWITTER]: TwitterIcon,
  [PlatFormEnum.LINKEDIN]: LinkedInPlatformIcon
};

export const PlatformContentIconLab: any = {
  [PlatformContentEnum.YOUTUBE_DEDICATED]: YoutubeIcon,
  [PlatformContentEnum.YOUTUBE_INTEGRATED]: YoutubeIcon,
  [PlatformContentEnum.TIKTOK_VIDEO]: TTIcon,
  // [PlatformContentEnum.TIKTOK_INTEGRATED_VIDEO]: TTIcon,
  [PlatformContentEnum.INSTAGRAM_REEL]: InstagramIcon,
  // [PlatformContentEnum.INSTAGRAM_INTEGRATED_REEL]: InstagramIcon,
  [PlatformContentEnum.INSTAGRAM_CAROUSEL_POST]: InstagramIcon,
  // [PlatformContentEnum.INSTAGRAM_INTEGRATED_CAROUSEL_POST]: InstagramIcon,
  [PlatformContentEnum.TWITTER_POST]: TwitterIcon,
  [PlatformContentEnum.LINKEDIN_POST]: LinkedInPlatformIcon,
  [PlatformContentEnum.LINKEDIN_IMAGE_POST]: LinkedInPlatformIcon,
  [PlatformContentEnum.LINKEDIN_VIDEO_POST]: LinkedInPlatformIcon,
  // [PlatformContentEnum.FACEBOOK_POST]: FacebookIcon,
  // [PlatformContentEnum.FACEBOOK_REEL]: FacebookIcon,
};

// 达人稿件状态
export enum orderManuscriptState {
  Collaboration_established = "Collaboration_established", // 达人申请制作
  Deal_confirmed = 'Deal_confirmed', // 一个状态集合的节点 (确定达人后 - 一稿前)
  Script_Submit = "ScriptSubmit",
  KickOff = 'KickOff',
  Address = 'Address',
  Script = "Script",
  ProductionKickoff = "ProductionKickoff",
  Creator_Address = "CreatorAddress",   // 达人填写地址
  Script_Approve = "ScriptApprove",  // 广告主审核脚本
  Draft_1 = "Draft_1",
  Draft_2 = "Draft_2",
  Draft_3 = "Draft_3",
  Draft_4 = "Draft_4",
  Draft_5 = "Draft_5",
  Final = "Final",
  Draft_1_Submit = "Draft_1_Submit",  // 达人提交1稿
  Draft_2_Submit = "Draft_2_Submit",
  Draft_3_Submit = "Draft_3_Submit",
  Draft_4_Submit = "Draft_4_Submit",
  Draft_5_Submit = "Draft_5_Submit",
  FinalSubmit = "FinalSubmit", // 达人提交最终稿
  Collaboration_cancelled= "Collaboration_cancelled",
  CreatorAccountInfo = 'CreatorAccountInfo', // 达人填写账号信息
  AccountInfo = 'AccountInfo',
  AccountSetup = 'AccountSetup', // 广告主给达人设置账号
}

interface ManuscriptStateTitle {
  [key: string]: string;
  Collaboration_established: string;
  Deal_confirmed: string;
  KickOff: string,
  Address: string,
  Script: string;
  Draft_1: string;
  Draft_2: string;
  Draft_3: string;
  Draft_4: string;
  Draft_5: string;
  Final: string;
  Collaboration_cancelled: string;
}
// 稿件显示标题
export const orderManuscriptStateTitle: ManuscriptStateTitle = {
  [orderManuscriptState.Collaboration_established]: 'orderDetail.manuscriptStates.influencerApplied',
  [orderManuscriptState.Deal_confirmed]: 'orderDetail.manuscriptStates.dealConfirmed',
  [orderManuscriptState.KickOff]: "orderDetail.manuscriptStates.kickoffProduction",
  [orderManuscriptState.Address]: "orderDetail.manuscriptStates.submitAddress",
  [orderManuscriptState.AccountInfo]: "orderDetail.manuscriptStates.submitAccount",
  [orderManuscriptState.Script]: 'orderDetail.manuscriptStates.script',
  [orderManuscriptState.Draft_1]: 'orderDetail.manuscriptStates.videoDraft1',
  [orderManuscriptState.Draft_2]: 'orderDetail.manuscriptStates.videoDraft2',
  [orderManuscriptState.Draft_3]: 'orderDetail.manuscriptStates.videoDraft3',
  [orderManuscriptState.Draft_4]: 'orderDetail.manuscriptStates.videoDraft4',
  [orderManuscriptState.Draft_5]: 'orderDetail.manuscriptStates.videoDraft5',
  [orderManuscriptState.Final]: 'orderDetail.manuscriptStates.finalLink',
  [orderManuscriptState.Collaboration_cancelled]: 'orderDetail.manuscriptStates.applicationRejected',
}

export const getOrderManuscriptStateTitle = (state: string, t: any) => {
  const key = orderManuscriptStateTitle[state] || '';
  return key ? t(key) : '';
}

// 广告主操作状态枚举
export enum AdsNextOperateType {
  CreatorApprove = 'CreatorApprove',
  ScriptApprove = 'ScriptApprove',
  Draft_1_Approve = 'Draft_1_Approve',
  Draft_2_Approve = 'Draft_2_Approve',
  Draft_3_Approve = 'Draft_3_Approve',
  Draft_4_Approve = 'Draft_4_Approve',
  Draft_5_Approve = 'Draft_5_Approve',
  OrderComplete = 'OrderComplete',
  ProductShipment = 'ProductShipment',
  InfluencerAccessSetup = 'AccountSetup',
}

export const getAdsOperateLab = (t: any) => ({
  [AdsNextOperateType.CreatorApprove]: t('components.adsOperateLab.confirmCollaboration'),
  [AdsNextOperateType.ScriptApprove]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_1_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_2_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_3_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_4_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.Draft_5_Approve]: t('components.adsOperateLab.approveDelivery'),
  [AdsNextOperateType.OrderComplete]: t('components.adsOperateLab.completeCollaboration'),
  [AdsNextOperateType.ProductShipment]: t('components.adsOperateLab.shipProduct'),
  [AdsNextOperateType.InfluencerAccessSetup]: t('components.adsOperateLab.influencerAccessSetup'),
});

// 触发付款的位置：用来区分后续的弹窗内容显示和样式； 影响范围：PayMethodModal、ModalUpdatePlan
export const payPlaceTypeLists = {
  ORDER_LIST: "orderList",  // 达人列表处
  CAMPAIGN_CREATE_RELEASE: "campaignCreateRelease", // 创建流程release处
  CAMPAIGN_CREATE_RELEASE_ACTIVE: "campaignCreateReleaseActive", // 创建流程release处 且是激活状态
}